/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useCallback } from "react"; // เพิ่ม useCallback
import axios from "axios";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Fullcalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";

import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TSCheckBox from "components/Forms/TSCheckBox";
import { Collapse, Modal, ModalBody } from "reactstrap";
import loading from "assets/img/loading-load.gif";
import TSText from "components/Forms/TSText";

import "react-datetime/css/react-datetime.css"
import "./custom-style.css";


const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none"
    }
};

const _color = [{ id: 1, forecolor: '#3788d8' }, { id: 2, forecolor: '#0E6251' }, { id: 3, forecolor: '#9A7D0A' }, { id: 4, forecolor: '#8E44AD' }, { id: 5, forecolor: '#E67E22' }, { id: 6, forecolor: '#6D4C41' }]

const useStyles = makeStyles(styles);


const Holiday = (props) => {
    var moment = require('moment');
    require('moment/locale/th');
    const [leaveAll, setLeaveAll] = useState([]);
    const [DefaultDate, setDefaultDate] = useState(moment().format("YYYY-MM-DD"));
    // eslint-disable-next-line
    const [ArrLeave, setArrLeave] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [HolidayKey, setHolidayKey] = useState(0);
    const [Note, setNote] = useState("");
    const [ENName, setENName] = useState("");
    const [Name, setName] = useState("");
    const [HolidayDate, setHolidayDate] = useState("");
    const [IsDisabled, setIsDisabled] = useState(false);

    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [errMsg, setErrMsg] = useState([]);
    const [modalError, setModalError] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");

    // eslint-disable-next-line
    const [isOpen, setIsOpen] = useState(false);

    // ใช้ useRef แทน createRef ใน Function Component
    const calendarRef = useRef(null);

    // ห่อ getMeeting ด้วย useCallback เพื่อแก้ปัญหา Dependency
    const getMeeting = useCallback((e) => {
        let month = e.getUTCMonth() + 1; //months from 1-12
        let year = e.getUTCFullYear();
        axios.get('/api/holiday/' + year + "/" + month)
            .then(
                result => {
                    const temp = [];
                    var data = result.data.data;
                    if (data.length >= 0) {
                        for (let i = 0; i < data.length; i++) {
                            var newObj = {
                                name: data[i].name
                                , holidayDate: data[i].holidayDate
                                , holidayDate2: data[i].holidayDate
                                , holidayKey: data[i].holidayKey.toString()
                                , note: data[i].note
                                , isDisabled: data[i].isDisabled
                                , enName: data[i].enName
                            }
                            temp.push(newObj);
                        }
                    }
                    var json = JSON.parse(JSON.stringify(temp).split('"name":').join('"title":').split('"holidayDate":').join('"start":')
                        .split('"holidayDate2":').join('"end":').split('"holidayKey":').join('"id":'));
                    if (json.length >= 0) {
                        setLeaveAll(json);
                    }

                },
                error => { alert(error); }
            );
    }, []);

    useEffect(() => {
        // แก้ไข eqeqeq: != เป็น !==
        if (DefaultDate !== null && DefaultDate !== '') {
            if (calendarRef.current) {
                let calendarApi = calendarRef.current.getApi();
                calendarApi.gotoDate(DefaultDate);
            }
        }
    }, [DefaultDate]);


    useEffect(() => {
        if (calendarRef.current) {
            let calendarApi = calendarRef.current.getApi();
            getMeeting(calendarApi.getDate())
        }
    }, [getMeeting]) // เพิ่ม getMeeting ใน dependency

    const handleConfirm = evt => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

        var holiday = {
            holidayDate: HolidayDate,
            name: Name,
            enName: ENName,
            note: Note,
            isDisabled: IsDisabled,
        }

        // แก้ไข eqeqeq: != เป็น !==
        if (HolidayKey !== 0 && HolidayKey !== '' && HolidayKey !== null) {
            axios.put('/api/holiday/' + HolidayKey, holiday)
                .then(
                    result => {

                        // แก้ไข eqeqeq: == เป็น ===
                        if (result.data.result === 200) {
                            setDefaultDate(result.data.data.holidayDate);
                            setIcon("far fa-question-circle");
                            setModal(false)
                            setModal2(true)
                            const date = new Date(result.data.data.holidayDate);
                            getMeeting(date);
                        }
                        else {
                            setIcon("far fa-question-circle");
                            setModal(false)
                            setErrMsg(result.data.msg)
                            setModalError(true)
                        }

                    },
                    error => { console.log(error); }
                );
        } else {
            axios.post('/api/holiday', holiday)
                .then(
                    result => {
                        // แก้ไข eqeqeq: == เป็น ===
                        if (result.data.result === 200) {
                            setHolidayKey(result.data.data.holidayKey);
                            setDefaultDate(result.data.data.holidayDate);
                            setIcon("far fa-question-circle");
                            setModal(false);
                            setModal2(true);
                            const date = new Date(result.data.data.holidayDate);
                            getMeeting(date);
                        } else {
                            setIcon("far fa-question-circle");
                            setModal(false);
                            setErrMsg(result.data.msg);
                            setModalError(true);
                        }

                    }, error => { console.log(error); }
                );
        }

    };


    const handleDateClick = (args) => {
        setDefaultDate(args.dateStr);
        setHolidayDate(args.dateStr)
        setHolidayKey(0);
        setName("");
        setENName("");
        setNote("");
        setIsDisabled(true);
    };

    const handleEventClick = (args) => {
        setDefaultDate(moment(args.event.start).format('YYYY-MM-DD'))
        setHolidayDate(moment(args.event.start).format('YYYY-MM-DD'))
        setHolidayKey(args.event._def.publicId);
        setName(args.event._def.title);
        setENName(args.event._def.extendedProps.enName === null ? " " : args.event._def.extendedProps.enName);
        setNote(args.event._def.extendedProps.note === null ? " " : args.event._def.extendedProps.note);
        setIsDisabled(args.event._def.extendedProps.isDisabled);
    };

    const handleSubmit = evt => {
        evt.preventDefault();
        var cntErr = 0;

        var errMsg = [];

        // แก้ไข eqeqeq: == เป็น ===
        if (HolidayDate === '') {
            cntErr += 1;
            errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุวันหยุด"}</li>);
        }

        // แก้ไข eqeqeq: == เป็น ===
        if (Name === '') {
            cntErr += 1;
            errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุชื่อวันหยุด"}</li>);
        }

        // แก้ไข eqeqeq: == เป็น ===
        if (ENName === '') {
            cntErr += 1;
            errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุชื่อภาษาอังกฤษ"}</li>);
        }

        if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
        } else {
            setModal(true);
        }
    };

    const classes = useStyles();
    return (

        <div>
            <Grid>
                <Col xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary">
                            <Grid>
                                <Col xs={6} sm={6} md={3}>
                                    <h4 className={classes.cardTitleWhite}>จัดการวันหยุด</h4>
                                </Col>
                            </Grid>
                        </CardHeader>
                        <CardBody>
                            <Grid>
                                {isLoading && (
                                    <>
                                        <Col xs={12} sm={12} md={12} style={{ textAlign: "center" }}>
                                            <img style={{ width: "50%" }} src={loading} alt="..." />
                                        </Col>
                                    </>
                                )}
                                {!isLoading && (<>
                                    <Col xs={12} sm={12} md={6}>
                                        <div style={{ textAlign: 'center' }}>
                                            <Fullcalendar
                                                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                                ref={calendarRef}
                                                initialView={"dayGridMonth"}
                                                headerToolbar={{
                                                    start: "title",
                                                    center: "",
                                                    end: "myCustomButton,myCustomButton2,myCustomButton3",
                                                }}
                                                hiddenDays={[0, 6]}
                                                height={"100vh"}
                                                dateClick={handleDateClick}
                                                events={leaveAll}
                                                droppable={true}
                                                rerenderDelay={10}
                                                eventDurationEditable={false}
                                                eventClick={handleEventClick}
                                                customButtons={{
                                                    myCustomButton: {
                                                        text: 'today',
                                                        click: function () {
                                                            let calendarApi = calendarRef.current.getApi();
                                                            calendarApi.today();
                                                            getMeeting(calendarApi.getDate());
                                                        }
                                                    },
                                                    myCustomButton2: {
                                                        text: '<',
                                                        click: function () {
                                                            let calendarApi = calendarRef.current.getApi();
                                                            calendarApi.prev();
                                                            getMeeting(calendarApi.getDate());
                                                        }
                                                    },
                                                    myCustomButton3: {
                                                        text: '>',
                                                        click: function () {
                                                            let calendarApi = calendarRef.current.getApi();
                                                            calendarApi.next();
                                                            getMeeting(calendarApi.getDate());
                                                        }
                                                    },
                                                }}
                                                locale={'th'}
                                                eventContent={renderEventContent}
                                                displayEventTime={false}
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={12} md={6} style={{ marginTop: "58px", backgroundColor: "#F4F4F4" }}>
                                        <Grid>
                                            <Col xs={12} sm={12} md={12}>
                                                <TSText icon="fas fa-calendar-alt" label="วันที่" value={HolidayDate} disabled={true} />
                                            </Col>
                                            <Col xs={12} sm={12} md={12}>
                                                <TSText icon="fas fa-edit" label="ชื่อวันหยุด" value={Name} onChange={e => setName(e.target.value)} />
                                            </Col>
                                            <Col xs={12} sm={12} md={12}>
                                                <TSText icon="fas fa-edit" label="ชื่อภาษาอังกฤษ" value={ENName} onChange={e => setENName(e.target.value)} />
                                            </Col>
                                            <Col xs={12} sm={12} md={12}>
                                                <TSText icon="fas fa-edit" label="หมายเหตุ" value={Note} onChange={e => setNote(e.target.value)} />
                                            </Col>
                                            <Col xs={12} sm={12} md={12}>
                                                {(!IsDisabled) ? <span style={{ color: 'green' }} >เปิดการใช้งานอยู่ </span> : <span style={{ color: 'red' }}>ปิดการใช้งานไปแล้ว </span>}<TSCheckBox checked={!IsDisabled} onChange={e => setIsDisabled(!IsDisabled)} />
                                            </Col>

                                            {/* แก้ไข eqeqeq: != เป็น !== */}
                                            {(HolidayKey !== 0 && HolidayKey !== '' && HolidayKey !== null) ?
                                                <Col xs={12} sm={12} md={12} style={{ height: "48px" }}>
                                                    <Button color="warning" onClick={handleSubmit} fullWidth>
                                                        <i className={"fa fa-edit"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }} ></i>
                                                        <h4>แก้ไข</h4>
                                                    </Button>
                                                </Col>
                                                :
                                                <Col xs={12} sm={12} md={12} style={{ height: "48px" }}>
                                                    <Button color="info" onClick={handleSubmit} fullWidth>
                                                        <i className={"fa fa-save"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }} ></i>
                                                        <h4>บันทึก</h4>
                                                    </Button>
                                                </Col>
                                            }

                                        </Grid>
                                    </Col>
                                </>)
                                }
                            </Grid>

                        </CardBody>
                        <CardFooter>
                            <Collapse isOpen={isOpen}>

                            </Collapse>
                            {/* Confirm */}
                            <Modal toggle={() => setModal(false)} isOpen={modal}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการบันทึกข้อมูล"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModal(false)}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button>

                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={handleConfirm}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <h4>ยืนยัน</h4>
                                    </Button>
                                </div>
                            </Modal>

                            {/* Success */}
                            <Modal toggle={() => setModal2(false)} isOpen={modal2}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={"fas fa-check"}
                                            style={{ color: "green", fontSize: "4em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center", fontSize: "1.8em"
                                        }}
                                    >
                                        บันทึกข้อมูลสำเร็จ
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="info"
                                        type="button"
                                        onClick={() => setModal2(false)}
                                    >
                                        <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ตกลง</h4>
                                    </Button>

                                </div>
                            </Modal>

                            {/* Error */}
                            <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className="fa fa-times"
                                            style={{ color: "red", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                    <div>{errMsg}</div>
                                </ModalBody>
                                <div className="modal-footer justify-content-center">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModalError(false)}
                                    >
                                        <h4>ตกลง</h4>
                                    </Button>
                                </div>
                            </Modal>
                        </CardFooter>
                    </Card>
                </Col>
            </Grid>
        </div>
    );


    function renderEventContent(eventInfo) {

        const _c = _color.find(c => c.id === 1);
        // แก้ไข eqeqeq: == เป็น ===
        const colorTxt = (_c !== undefined) ? ((eventInfo.event.extendedProps.isDisabled === true) ? 'red' : _c.forecolor) : '#000000';

        // แก้ไข eqeqeq: == เป็น ===
        const strikeTxt = (eventInfo.event.extendedProps.isDisabled === true) ? 'line-through' : '';

        return (
            <>
                <div className="fc-event-time" style={{ color: colorTxt, textDecoration: strikeTxt }}> {eventInfo.timeText}</div>
                <div className="fc-event-title" style={{ color: colorTxt, textDecoration: strikeTxt }}> {eventInfo.event.title}</div>
            </>
        )
    }
}

export default Holiday;